export default "__VITE_ASSET__$KdsBHNr__"